import BaseService from "../baseService";
class Descontos extends BaseService {
  constructor(id) {
    const resource = "limpa-desconto-pecas";
    let relationship = {
      logs: "logs",
    };
    super(id, relationship, resource);
  }
}

export default (id) => new Descontos(id);
